import { useQueryClient } from '@tanstack/react-query';
import { useApplicationLocalStorage } from '../../application-hook';
import { F5ApplicationParameters } from '@platform/client/schemas';
import { useState } from 'react';
import { ApplicationPageProps } from '../../Application';
import { Application, Cohorts } from '@platform/client';
import { CohortDetails } from '../../program/shared/CohortDetails';
import { ErrorBox } from '@platform/components';


export const F5ConfirmAndSubmit = (props: ApplicationPageProps) => {
	const [failed, setFailed] = useState(false);
	const { getApplicationData } = useApplicationLocalStorage<F5ApplicationParameters>(
		props.dataKey,
	);
	const { data: cohortData, isSuccess } = Cohorts.useGetCurrentUserCurrentCohort();
	const submitF5Mutation = Application.useSubmitF5Application();
	const queryClient = useQueryClient();

	const submit = () => {
		submitF5Mutation.mutate(
			{
				data: {
					...getApplicationData(),
				},
			},
			{
				onSuccess: () => {
					queryClient.invalidateQueries({
						queryKey: Application.getGetProfessionalApplicationStatusQueryKey(),
					});
				},
				onError: () => {
					setFailed(true);
				},
			},
		);
	};

	return (
		<>
			{isSuccess && cohortData && <CohortDetails {...props} cohortData={cohortData} onSubmit={submit} />}
			{
				failed && (
					<ErrorBox showAlertTriangle={true}>
						There was an error submitting your application. Please try again later.
					</ErrorBox>
				)
			}
		</>
	);
};
